/** A request failed: a non-2xx status, or an envelope with `success: false`. `body` is the parsed error body. */
export class ApiStatusError extends Error {
    constructor(
        public readonly status: number,
        public readonly body: unknown,
    ) {
        super(`API request failed with status ${status}`);
        this.name = 'ApiStatusError';
    }
}
